/** 组件编辑外层拖拽，可编辑按钮，缩放改变盒子大小 */
<template>
  <div
    class="components-edit-shape"
    @click="handleTopWrapperClick"
    @mousedown="handleMouseDownOnElement"
    :class="{
      active: true,
      'element-on-edit-pane-hide': defaultStyle.display == 'none',
    }"
    :style="getCommonStyle(activeElementGroup.display?{...defaultStyle, display: activeElementGroup.display}:defaultStyle)"
  >
    <div
      class="edit-shape-point"
      v-for="item in pointList"
      :key="item"
      @mousedown.stop.prevent="handleMouseDownOnPoint(item)"
      :style="getPointStyle(item)"
    ></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import editorProjectConfig from "@client/pages/editor/DataModel";
export default {
  name: "EditShapeGroup",
  props: {
    // canvas画板缩放
    scale: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      getCommonStyle: editorProjectConfig.getCommonStyle,
      // l = left, t = top, r = right, b = bottom
      pointList: ["lt", "rt", "lb", "rb", "l", "r", "t", "b"],
      // 上下左右 对应的 东南西北
      directionKey: {
        t: "n",
        b: "s",
        l: "w",
        r: "e",
      },
      relativeData: [],
    };
  },
  computed: {
    ...mapState({
      projectData: (state) => state.editor.projectData,
      activePageUUID: (state) => state.editor.activePageUUID,
      activeElementUUID: (state) => state.editor.activeElementUUID,
      activeElementUUIDMore: (state) => state.editor.activeElementUUIDMore,
      activeElementGroupUUID: (state) => state.editor.activeElementGroupUUID,
    }),
    ...mapGetters([
      "currentPageIndex",
      "activeElementIndex",
      "activeElement",
      "activePage",
      "activeElementGroup",
    ]),
    defaultStyle() {
      let elements = [],
        elementsInfo = [];
      if (this.activePage.elementGroups) {
        if (
          this.activePage.elementGroups.find(
            (i) => i.uuid == this.activeElementGroupUUID
          )
        ) {
          elements = this.activePage.elementGroups.find(
            (i) => i.uuid == this.activeElementGroupUUID
          ).list;
        }
      }
      let minLeft = 9999,
        minTop = 9999,
        maxRight = 0,
        maxBottom = 0;
      elements.map((i) => {
        const elem = this.activePage.elements
          .filter((m) => !!m)
          .find((m) => m.uuid == i);
        if (elem) {
          elementsInfo.push(elem);
          if (elem.commonStyle.left < minLeft) {
            minLeft = elem.commonStyle.left; // 更新最小left值
          }
          if (elem.commonStyle.top < minTop) {
            minTop = elem.commonStyle.top; // 更新最小top值
          }
          if (elem.commonStyle.left + elem.commonStyle.width > maxRight) {
            maxRight = elem.commonStyle.left + elem.commonStyle.width; // 更新最大right值
          }
          if (elem.commonStyle.top + elem.commonStyle.height > maxBottom) {
            maxBottom = elem.commonStyle.top + elem.commonStyle.height; // 更新最大bottom值
          }
        }
      });
      return {
        width: maxRight - minLeft,
        height: maxBottom - minTop,
        left: minLeft,
        top: minTop,
        position: "absolute",
        zIndex: 99,
      };
    },
  },
  watch: {
    defaultStyle(val) {
      this.activeElementGroup["defaultStyle"] = val;
    },
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.initRelativeData();
        this.activeElementGroup["defaultStyle"] = this.defaultStyle;
        console.log(this.activeElementGroup, "activeElementGroup-mounted");
      });
    }, 0);
  },
  methods: {
    initRelativeData(){
      // 标记此时内部元件在组内的相对位置、大小（百分比）
      let elements = [];
      if (this.activePage.elementGroups) {
        elements = this.activePage.elementGroups.find(
          (i) => i.uuid == this.activeElementGroupUUID
        ).list;
      }
      elements.map((i) => {
        const elem = this.activePage.elements
          .filter((m) => !!m)
          .find((m) => m.uuid == i);
        if (elem) {
          this.relativeData.push({
            uuid: elem.uuid,
            left:
              (elem.commonStyle.left - this.defaultStyle.left) /
              this.defaultStyle.width,
            top:
              (elem.commonStyle.top - this.defaultStyle.top) /
              this.defaultStyle.height,
            width: elem.commonStyle.width / this.defaultStyle.width,
            height: elem.commonStyle.height / this.defaultStyle.height,
            rotateX:
              ((this.defaultStyle.left +
                this.defaultStyle.width / 2 -
                elem.commonStyle.left) /
                elem.commonStyle.width) *
              100,
            rotateY:
              ((this.defaultStyle.top +
                this.defaultStyle.height / 2 -
                elem.commonStyle.top) /
                elem.commonStyle.height) *
              100,
          });
        }
      });
      this.activeElementGroup["relativeData"] = this.relativeData;
    },
    /**
     * 获取point计算后样式
     * @param point
     * @returns {{}}
     */
    getPointStyle(point) {
      const pos = this.defaultStyle;
      const height = pos.height;
      const width = pos.width;
      let hasT = /t/.test(point);
      let hasB = /b/.test(point);
      let hasL = /l/.test(point);
      let hasR = /r/.test(point);
      let newLeft = 0;
      let newTop = 0;
      if (point.length === 2) {
        newLeft = hasL ? 0 : width;
        newTop = hasT ? 0 : height;
      } else {
        // !#zh 上下点，宽度固定在中间
        if (hasT || hasB) {
          newLeft = width / 2;
          newTop = hasT ? 0 : height;
        }
        // !#zh 左右点，高度固定在中间
        if (hasL || hasR) {
          newLeft = hasL ? 0 : width;
          newTop = height / 2;
        }
      }
      const style = {
        marginLeft: hasL || hasR ? "-5px" : 0,
        marginTop: hasT || hasB ? "-5px" : 0,
        left: `${newLeft}px`,
        top: `${newTop}px`,
        cursor:
          point
            .split("")
            .reverse()
            .map((m) => this.directionKey[m])
            .join("") + "-resize",
      };
      return style;
    },
    /**
     * 点击事件，点击后设置当前元素为选中元素
     */
    handleTopWrapperClick(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    /**
     * 鼠标选中元素拖拽事件
     * @param e
     */
    handleMouseDownOnElement(e) {
      e.stopPropagation();
      e.preventDefault();
      // 抛出事件让父组件设置当前元素选中状态
      // 获取鼠标点击的位置，于整个遮罩的相对位置x、y
      let rect = e.target.getBoundingClientRect(); // 获取目标div的位置和大小信息
      let offsetX = e.clientX - rect.left; // 计算鼠标点击位置相对于目标div的横坐标偏移量
      let offsetY = e.clientY - rect.top; // 计算鼠标点击位置相对于目标div的纵坐标偏移量
      const relativeBingo = this.relativeData.find(
        (i) =>
          offsetX / rect.width > i.left &&
          offsetX / rect.width < i.left + i.width &&
          offsetY / rect.height > i.top &&
          offsetY / rect.height < i.top + i.height
      );

      //   const pos = { ...this.defaultStyle };
      let startY = e.clientY;
      let startX = e.clientX;
      //   let startTop = pos.top;
      //   let startLeft = pos.left;
      let firstTime = "",
        lastTime = "";
      firstTime = new Date().getTime();
      let elements = [];
      if (this.activePage.elementGroups) {
        elements = this.activePage.elementGroups
          .find((i) => i.uuid == this.activeElementGroupUUID)
          .list.map((i) => {
            const elemIndex = this.activePage.elements.findIndex(
              (m) => m.uuid == i
            );
            return {
              index: elemIndex,
              uuid: this.activePage.elements[elemIndex].uuid,
              top: this.activePage.elements[elemIndex].commonStyle.top,
              left: this.activePage.elements[elemIndex].commonStyle.left,
            };
          });
      }
      let move = (moveEvent) => {
        // !#zh 移动的时候，不需要向后代元素传递事件，只需要单纯的移动就OK
        moveEvent.stopPropagation();
        moveEvent.preventDefault();

        let currX = moveEvent.clientX;
        let currY = moveEvent.clientY;
        // pos.top = (currY - startY) * (1 / this.scale) + startTop;
        // pos.left = (currX - startX) * (1 / this.scale) + startLeft;
        elements.map((i) => {
          this.activePage.elements[i.index].commonStyle.top =
            (currY - startY) * (1 / this.scale) + i.top;
          this.activePage.elements[i.index].commonStyle.left =
            (currX - startX) * (1 / this.scale) + i.left;
        });
        // pos.top = currY - startY + startTop
        // pos.left = currX - startX + startLeft
        // this.$emit("resize", pos);
      };
      let up = () => {
        lastTime = new Date().getTime();
        if (lastTime - firstTime > 200) {
          this.$emit("resize");
        }
        document.removeEventListener("mousemove", move, true);
        document.removeEventListener("mouseup", up, true);
        // todo
        if (lastTime - firstTime < 500 && relativeBingo && relativeBingo.uuid) {
          this.$emit("handleElementClick", {
            uuid: relativeBingo.uuid || "",
          });
        }
      };
      document.addEventListener("mousemove", move, true);
      document.addEventListener("mouseup", up, true);
      return true;
    },
    /**
     * 鼠标点击可以的按钮resize事件
     * @param point
     * @param downEvent
     */
    handleMouseDownOnPoint(point) {
      let downEvent = event;
      // 抛出事件让父组件设置当前元素选中状态
      //   this.$emit("handleElementClick");
      downEvent.stopPropagation();
      downEvent.preventDefault(); // Let's stop this event.
      const pos = { ...this.defaultStyle };
      let height = pos.height;
      let width = pos.width;
      let top = pos.top;
      let left = pos.left;
      let startX = downEvent.clientX;
      let startY = downEvent.clientY;
      let move = (moveEvent) => {
        let currX = moveEvent.clientX;
        let currY = moveEvent.clientY;
        let disY = currY - startY;
        let disX = currX - startX;
        let hasT = /t/.test(point);
        let hasB = /b/.test(point);
        let hasL = /l/.test(point);
        let hasR = /r/.test(point);
        let newHeight = +height + (hasT ? -disY : hasB ? disY : 0);
        let newWidth = +width + (hasL ? -disX : hasR ? disX : 0);
        const resultHeight = newHeight > 0 ? newHeight : 0;
        const resultWidth = newWidth > 0 ? newWidth : 0;
        const resultLeft = +left + (hasL ? disX : 0);
        const resultTop = +top + (hasT ? disY : 0);
        this.relativeData.map((i) => {
          const elemIndex = this.activePage.elements.findIndex(
            (m) => m.uuid == i.uuid
          );
          this.activePage.elements[elemIndex].commonStyle.top =
            resultTop + i.top * resultHeight;
          this.activePage.elements[elemIndex].commonStyle.left =
            resultLeft + i.left * resultWidth;
          this.activePage.elements[elemIndex].commonStyle.width =
            i.width * resultWidth;
          this.activePage.elements[elemIndex].commonStyle.height =
            i.height * resultHeight;
        });
        // this.$emit("resize");
      };
      let up = () => {
        this.$emit("resize");
        document.removeEventListener("mousemove", move);
        document.removeEventListener("mouseup", up);
      };
      document.addEventListener("mousemove", move);
      document.addEventListener("mouseup", up);
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-shape-point {
  width: 10px;
  height: 10px;
  background-color: #fff;
  border: 1px solid #59c7f9;
  border-radius: 10px;
  position: absolute;
  z-index: 1001;
}

.components-edit-shape {
  cursor: move;
  &.active {
    outline: 1px dashed #416bf4;
  }
  &:hover {
    outline: 1px dashed #416bf4;
  }
  &.element-on-edit-pane-hide {
    &::after {
      content: "";
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: 3px dashed #0655cd;
      position: absolute;
    }
  }
}
</style>
